export default "__VITE_ASSET__1e8940a5__"